import { all, call, put, select, take, takeLatest, getContext } from 'redux-saga/effects';
import clearStorages from 'helpers/clearStorages';
import SessionStorage from 'libs/SessionStorage';
import ApiService from 'services/ApiService';
import OidcService from 'services/OidcService';
import App from 'modules/App';
import Account from 'modules/Account';
import Information from 'modules/Information';
import Setup from 'modules/Setup';
import * as actionTypes from './actionTypes';
import * as actions from './actions';
import messages from './messages';
function* restoreSSO({ payload }) {
    const { restoreSsoAt, fullPath } = payload;
    try {
        if (restoreSsoAt) {
            const apiUrl = yield getContext('apiUrl');
            const region = yield select(App.selectors.originalRegionName);
            const requestUrl = `${apiUrl}/aid/api/${region}/Account/RestoreSSO`;
            yield call(ApiService.plainRequest, requestUrl, {
                method: 'POST',
                credentials: 'include',
                headers: {
                    Authorization: `Bearer ${restoreSsoAt}`
                }
            });
        }
    } catch (err) {
    // No action
    } finally{
        clearStorages(true);
        SessionStorage.setItem('returnPathname', fullPath);
        yield call(OidcService.login);
    }
}
//----------------------------------------------------------------------------------------------------------------------
function* patientSetup({ payload }) {
    try {
        const { createPatientProfile, updateInformations, updateAccountSettings } = payload;
        const { createPatientValues, authorizationCode, standards, enrollCode, invitationCode } = createPatientProfile;
        const calls = [
            put(Setup.actions.createPatientProfile(createPatientValues, authorizationCode, standards, enrollCode, invitationCode))
        ];
        const takes = [
            take([
                Account.actionTypes.CREATE_PATIENT_PROFILE_SUCCESS,
                Account.actionTypes.CREATE_PATIENT_PROFILE_ERROR
            ])
        ];
        if (updateInformations) {
            calls.push(put(Information.actions.updateInformation(updateInformations)));
            takes.push(take([
                Information.actionTypes.UPDATE_INFORMATION_SUCCESS,
                Information.actionTypes.UPDATE_INFORMATION_ERROR
            ]));
        }
        if (updateAccountSettings) {
            calls.push(put(Account.actions.updateAccountSettings(updateAccountSettings)));
            takes.push(take([
                Account.actionTypes.UPDATE_ACCOUNT_SETTINGS_SUCCESS,
                Account.actionTypes.UPDATE_ACCOUNT_SETTINGS_ERROR
            ]));
        }
        yield all(calls);
        const [createPatientProfileResult, updateInformationResult, updateAccountSettingsResult] = yield all(takes);
        if (createPatientProfileResult.type === Account.actionTypes.CREATE_PATIENT_PROFILE_ERROR) {
            yield put(actions.patientSetupError(createPatientProfileResult.error));
            return;
        }
        if (updateInformationResult && updateInformationResult.type === Information.actionTypes.UPDATE_INFORMATION_ERROR) {
            yield put(actions.patientSetupError(updateInformationResult.error));
            return;
        }
        if (updateAccountSettingsResult && updateAccountSettingsResult.type === Account.actionTypes.UPDATE_ACCOUNT_SETTINGS_ERROR) {
            yield put(actions.patientSetupError(updateAccountSettingsResult.error));
            return;
        }
        yield put(actions.patientSetupSuccess());
    } catch (err) {
        yield put(actions.patientSetupError(err));
        yield call(App.dispatchError, err, messages);
    }
}
function* sagas() {
    yield takeLatest(actionTypes.RESTORE_SSO, restoreSSO);
    yield takeLatest(actionTypes.PATIENT_SETUP, patientSetup);
}
export default [
    sagas
];
